import Loader from "../components/Loader/Loader";

function LoaderPage() {
  /* -------------------------------- */
  /* RENDER METHODS */
  /* -------------------------------- */
  function render() {
    return (
      <div className="flex justify-center items-center my-8">
        <Loader />
      </div>
    );
  }
  return render();
}

export default LoaderPage;
